/** 读数格式化。集中在一处，避免同一个数字在两张表里精度不同（那种差异看起来像数据错） */

export const EM_DASH = '—';

export function fixed(value: number | null, digits: number): string {
  return value === null || Number.isNaN(value) ? EM_DASH : value.toFixed(digits);
}

export function integer(value: number | null): string {
  return value === null || Number.isNaN(value) ? EM_DASH : String(Math.round(value));
}

/**
 * 经纬度固定 6 位小数（约 0.11 米）：再少就看不出悬停时的漂移，
 * 再多则是把 degE7 的精度当成真值去展示。
 */
export function coordinate(value: number | null): string {
  return fixed(value, 6);
}

export function scaled(value: number | null, divisor: number, digits: number): string {
  return value === null ? EM_DASH : fixed(value / divisor, digits);
}

/** 速度：`GLOBAL_POSITION_INT` 的 vx/vy 是 NED 分量，界面要的是合速度 */
export function groundSpeed(vxMps: number | null, vyMps: number | null): string {
  if (vxMps === null || vyMps === null) return EM_DASH;
  return Math.hypot(vxMps, vyMps).toFixed(2);
}

export function ageText(ageMs: number | null): string {
  if (ageMs === null) return '从未收到';
  if (ageMs < 1000) return `${Math.round(ageMs)} 毫秒前`;
  if (ageMs < 60_000) return `${(ageMs / 1000).toFixed(1)} 秒前`;
  return `${Math.round(ageMs / 60_000)} 分钟前`;
}

export function clockText(at: number): string {
  return new Date(at).toLocaleTimeString('zh-CN', { hour12: false });
}
